// © Microsoft Corporation. All rights reserved.
/**
 * This file and util is mainly done for Widget integration in Channel app, including Skype/Outlook/Office/etc..
 */
import { createScriptTag } from "@msnews/isomorphic-util";
/**
 * determine if the given script name is OneTrust script name
 * @param scriptData expect to be the type of CookieBannerData
 * @returns true if the scriptData matches with CookieBannerData
 */
export function isOneTrustScriptData(scriptData) {
    return !!(scriptData && scriptData.oneTrustDataDomainScriptID && scriptData.oneTrustSdkPath);
}
/**
 * try to add OneTrust script element to head if it the given bootstrappingRefs has OneTrust script
 * @param cookieBannerData an object of cookieBannerData
 */
export function setOneTrustScript(cookieBannerData) {
    if (!cookieBannerData) {
        return;
    }
    const { oneTrustDataDomainScriptID, oneTrustSdkPath } = cookieBannerData;
    if (!oneTrustDataDomainScriptID || !oneTrustSdkPath) {
        return;
    }
    const scriptElement = createScriptTag(oneTrustSdkPath, "onetrust-sdk", true, "anonymous");
    const dataDocLangAttr = document.createAttribute("data-document-language");
    dataDocLangAttr.value = "true";
    scriptElement.attributes.setNamedItem(dataDocLangAttr);
    const charsetAttr = document.createAttribute("charset");
    charsetAttr.value = "UTF-8";
    scriptElement.attributes.setNamedItem(charsetAttr);
    const dataDomainScriptAttr = document.createAttribute("data-domain-script");
    dataDomainScriptAttr.value = oneTrustDataDomainScriptID;
    scriptElement.attributes.setNamedItem(dataDomainScriptAttr);
    document.head.appendChild(scriptElement);
}
//# sourceMappingURL=SetOneTrustScript.js.map